export default "__VITE_ASSET__bb30f43d__"